import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isOpen: false,
    stack: []
};

export const drawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        openDrawer: (state, action) => {
            const layer = {
                tools: action.payload?.tools || null,
                content: action.payload?.content || null,
                footer: action.payload?.footer || null
            };

            state.stack.push(layer);
            state.isOpen = true;
        },
        closeDrawer: (state) => {
            state.stack.pop();

            if (state.stack.length === 0) {
                state.isOpen = false;
            }
        },
        closeAllDrawers: (state) => {
            state.stack = [];
            state.isOpen = false;
        }
    }
});

export const { openDrawer, closeDrawer, closeAllDrawers } = drawerSlice.actions;

export default drawerSlice.reducer;